import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom"; // <-- import useLocation
import logoImage from "../assets/logo_qdriver.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();  // <-- lấy pathname hiện tại

  const links = [
    { name: "GIỚI THIỆU", href: "/gioi-thieu" },
    { name: "KHÓA HỌC", href: "/khoa-hoc" },
    { name: "CẨM NANG", href: "/cam-nang" },
    { name: "TIN TỨC", href: "/tin-tuc" },
    { name: "LIÊN HỆ", href: "/lien-he" },
  ];

  // Không cần activeLink trong state nữa
  const handleClick = () => {
    setIsOpen(false); // đóng menu mobile khi click link
  };

  return (
    <nav className="bg-white shadow-md fixed w-full top-0 left-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20 items-center">
          {/* Logo */}
          <Link to="/" onClick={() => setIsOpen(false)}>
            <img src={logoImage} alt="Logo" className="h-16 object-contain" />
          </Link>

          {/* Desktop menu */}
          <div className="hidden md:flex space-x-8 text-lg">
            {links.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                onClick={handleClick}
                className={`relative px-2 py-1 transition-all duration-300 rounded-md ${
                  location.pathname.startsWith(link.href)
                    ? "text-red-600 font-semibold"
                    : "text-gray-700"
                } hover:text-red-500 hover:bg-red-100`}
              >
                {link.name}
                {location.pathname.startsWith(link.href) && (
                  <span className="absolute left-0 -bottom-0.5 h-0.5 w-full overflow-hidden">
                    <span className="block h-full bg-red-600 animate-underlineSlide"></span>
                  </span>
                )}
              </Link>
            ))}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-red-700 focus:outline-none"
            >
              {isOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile dropdown */}
      {isOpen && (
        <div className="md:hidden absolute top-16 right-4 bg-white rounded-md shadow-lg p-2 w-max z-50">
          <div className="flex flex-col text-base min-w-[160px]">
            {links.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                onClick={handleClick}
                className={`relative px-4 py-2 rounded-full transition-all duration-300 flex items-center justify-center
            border-2 border-transparent
            ${
              location.pathname.startsWith(link.href)
                ? "bg-red-100 text-red-600 font-semibold animate-borderSlide border-red-600"
                : "bg-gray-100 text-gray-800 hover:bg-gray-200"
            }
          `}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;